import { pantryColors } from '@pantry/ui'
import React from 'react'
import { CouponCustomerPicker } from './CouponCustomerPicker'

const p = pantryColors

const fieldLabelStyle: React.CSSProperties = {
  display: 'block',
  fontSize: 11.5,
  fontWeight: 600,
  color: p.gray[600],
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  marginBottom: 6,
}

const OPTIONS: ReadonlyArray<{ specific: boolean; label: string }> = [
  { specific: false, label: 'All customers' },
  { specific: true, label: 'Specific customers' },
]

interface Props {
  restrictToSpecific: boolean
  emails: string[]
  onModeChange: (specific: boolean) => void
  onEmailsChange: (emails: string[]) => void
}

/**
 * "Customer eligibility" section of the coupon modal. Chooses between All
 * customers (no restriction) and Specific customers (an email allow-list), and
 * renders the search-and-chips picker in the Specific case. Reproduces the
 * legacy per-POS coupon customer restriction; persisted as `email_restrictions`.
 */
export const CouponCustomerEligibility: React.FC<Props> = ({
  restrictToSpecific,
  emails,
  onModeChange,
  onEmailsChange,
}) => (
  <div>
    <div style={fieldLabelStyle}>Customer scope</div>
    <div
      style={{
        display: 'inline-flex',
        gap: 4,
        padding: 3,
        background: p.gray[100],
        borderRadius: 8,
      }}
    >
      {OPTIONS.map(({ specific, label }) => {
        const active = specific === restrictToSpecific
        return (
          <button
            key={label}
            type="button"
            onClick={() => onModeChange(specific)}
            style={{
              padding: '6px 12px',
              fontSize: 12.5,
              fontWeight: 600,
              borderRadius: 6,
              border: 'none',
              background: active ? p.white : 'transparent',
              color: active ? p.gray[800] : p.gray[500],
              cursor: 'pointer',
              boxShadow: active ? '0 1px 2px rgba(15, 23, 42, 0.08)' : 'none',
            }}
          >
            {label}
          </button>
        )
      })}
    </div>

    {restrictToSpecific ? (
      <div style={{ marginTop: 12 }}>
        <CouponCustomerPicker emails={emails} onChange={onEmailsChange} />
      </div>
    ) : (
      <div style={{ marginTop: 8, fontSize: 12, color: p.gray[500] }}>
        Any customer can redeem this coupon.
      </div>
    )}
  </div>
)
